export default function isSameStringIgnoreCase(str1: string, str2: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (5,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return str1 == str2 || (str1 && str2 && str1.toLowerCase() == str2.toLowerCase());
}
